import { differenceInCalendarDays } from 'date-fns'
import { isDate, isEmpty } from 'lodash'
import { createSelector } from 'reselect'
import { IStore } from '../../index'

export function getFilteringOptions(state: IStore) {
  return state.bookingCalendar.filtering
}

export const getPlaceFiltering = createSelector(
  [getFilteringOptions],
  filters => filters.byPlace,
)

export const getDateFiltering = createSelector(
  [getFilteringOptions],
  filters => ({
    from: filters.byDate.from,
    size: differenceInCalendarDays(filters.byDate.to, filters.byDate.from),
    to: filters.byDate.to,
  }),
)

export const isFilteringByDateEnabled = createSelector(
  [getFilteringOptions],
  ({ byDate }) => isDate(byDate.from) && isDate(byDate.to),
)

export const isFilteringByPersonsEnabled = createSelector(
  [getFilteringOptions],
  ({ byPlace }) => byPlace.persons > 0,
)

export const isFilteringByPlaceEnabled = createSelector(
  [getFilteringOptions],
  ({ byPlace }) => !isEmpty(byPlace.name),
)

export const getEnabledFilters = createSelector(
  [
    isFilteringByDateEnabled,
    isFilteringByPlaceEnabled,
    isFilteringByPersonsEnabled,
  ],
  (byDate, byPlace, byPersons) =>
    [byDate, byPlace, byPersons].reduce((a, b) => a + Number(b), 0),
)
